import { render } from "./XFstatistics.vue?vue&type=template&id=2a6354ed&scoped=true"
import script from "./XFstatistics.vue?vue&type=script&lang=js"
export * from "./XFstatistics.vue?vue&type=script&lang=js"

import "./XFstatistics.vue?vue&type=style&index=0&id=2a6354ed&lang=scss&scoped=true"
import "./XFstatistics.vue?vue&type=style&index=1&id=2a6354ed&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6354ed"]])

export default __exports__